// actions/digging.ts — M2
import { defineAction } from '../define';
import { g } from '../guard';
import type { ItemView } from '../../types/items';
declare module '../registry' {
  interface ActionMap { 'dig.dig': { req: { spot: string }; res: { item: ItemView } } }
}
export const digDig = defineAction('dig.dig', g.obj({ spot: g.token }));
